import { Music } from 'lucide-react';
import { trackClick } from '@/lib/track';

const SPOTIFY_URL = "https://open.spotify.com/album/4lRxqkaO3Fl2k4zW8RFh0F";

export default function SpotifyPlayer() {
  const handleClick = () => {
    trackClick({ film: 'gws2-ost', platform: 'spotify', action: 'click', section: 'floating_player' });
  };

  return (
    <a
      href={SPOTIFY_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Listen to the Ginny Weds Sunny 2 soundtrack on Spotify"
      data-testid="spotify-player"
      onClick={handleClick}
      className="fixed bottom-5 right-5 z-[95] flex items-center justify-center transition-all duration-300 hover:scale-110 rounded-full"
      style={{ width: '56px', height: '56px', background: '#1a1a1a', border: '1px solid rgba(201,168,76,0.25)', boxShadow: '0 4px 20px rgba(0,0,0,0.5)' }}
    >
      <Music className="w-5 h-5" style={{ color: 'var(--gold)' }} strokeWidth={1.5} />
    </a>
  );
}
